import axios from 'axios';

/** Base URL for API (build-time override). */
export const API_BASE =
  process.env.REACT_APP_API_BASE || 'https://bjjsearch-v2.planetven.us';

/** Axios instance that sends Bearer token when `access_token` is in localStorage. */
export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
